import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FitTextComponent } from './fit-text.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FitTextComponent],
  exports: [FitTextComponent]
})
export class FitTextModule { }
